import React from 'react';
import Header from '../header/Header';
import Thread from '../thread/Thread';
import { Scenario } from '../../stores/scenarioState';
import "./Frame.css";
import "./Color.css";

interface FrameProps {
  param: Scenario;
  color: string;
}

const Frame: React.FC<FrameProps> = props => {
  return (
    <div className={`frame-wrapper frame-${props.color}`}>
      <div className="frame">
        <React.Suspense fallback={<pre>Loading...</pre>}>
          <Header/>
          <Thread/>
        </React.Suspense>
      </div>
    </div>
  );
};

export default Frame;
